import { lazy } from 'react';
import { Navigate, useLocation, useRoutes } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import Loadable from 'ui-component/Loadable';

const PagesLanding = Loadable(lazy(() => import('views/pages/landing')));

// /mypage（クエリ・ハッシュ付き含む）→ /subscription へ。SPA 内遷移でも foidtk 等を落とさない
const MypageToSubscriptionRedirect = () => {
    const { search, hash } = useLocation();
    return <Navigate to={{ pathname: '/subscription', search, hash }} replace />;
};

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    // return useRoutes([{ path: '/', element: <PagesLanding /> }, AuthenticationRoutes, LoginRoutes, MainRoutes]);
    return useRoutes([
        { path: '/mypage', element: <MypageToSubscriptionRedirect /> },
        { path: '/mypage/', element: <MypageToSubscriptionRedirect /> },
        LoginRoutes,
        AuthenticationRoutes,
        MainRoutes
    ]);
}
